import { HEADER_EYEBROW, HEADER_SUBHEAD, HEADER_TITLE } from '../constants';
import { ActionsSlot, Eyebrow, HeaderRoot, Subhead, Title, TitleGroup } from './styled';
import type { HeaderProps } from './types';

const Header = ({ actions }: HeaderProps) => (
  <HeaderRoot data-testid="idv-header">
    <TitleGroup>
      <Eyebrow>{HEADER_EYEBROW}</Eyebrow>
      <Title>{HEADER_TITLE}</Title>
      <Subhead>{HEADER_SUBHEAD}</Subhead>
    </TitleGroup>
    {actions ? <ActionsSlot>{actions}</ActionsSlot> : null}
  </HeaderRoot>
);

export default Header;
